import dayjs from 'dayjs'
import _ from 'lodash'

const stores = []

/**
 * @template T
 * @param {function(new: T)} type
 * @param {string} storeKey
 * @returns {T}
 */
export const getStore = <T, U>(
  type: new (dataInitiated?: U) => T,
  storeKey: string,
  dataInitiated?: U
): T => {
  if (!(type as any).storeName) {
    throw new Error('Missing storeName in store class')
  }
  const storeName = (type as any).storeName
  let key = `${storeName}-${storeKey}`
  let store = stores[key]
  if (!store) {
    store = new type(dataInitiated)
    stores[key] = store
  }

  return store
}

export const checkDataChange = (originData, data) => {
  const obj1 = _.cloneDeep(originData)
  const obj2 = _.cloneDeep(data)
  return !_.isEqual(obj1, obj2)
}
export const getDueDayinMonthOption = (): any[] => {
  let result = []
  for (let i = 1; i <= 25; i++) {
    result.push({ id: i, displayName: `${i}${nthNumber(i)}` })
  }
  return result
}

export const nthNumber = number => {
  if (number > 3 && number < 21) {
    return 'th'
  }
  switch (number % 10) {
    case 1:
      return 'st'
    case 2:
      return 'nd'
    case 3:
      return 'rd'
    default:
      return 'th'
  }
}

export const getSpecialistProviderNoOptions = (
  specialist,
  isCaseManager = false
) => {
  if (!specialist) {
    return []
  }
  const items = specialist.providerNumbers ?? []
  return items
    .filter(p => p.number)
    .map(p => ({
      // Option value is now the stable provider-number GUID (was the 1-based order).
      id: p.id,
      displayName: `${p.number}${
        isEffectiveProviderNumber(p) ? '' : ' (Expired)'
      } ${!isCaseManager && p.note ? ' - ' + p.note?.slice(0, 50) : ''}`,
    }))
}

export const isEffectiveProviderNumber = (item): boolean => {
  const today = new Date()
  const from = item.effectiveFrom ? new Date(item.effectiveFrom) : null
  const to = item.effectiveTo ? new Date(item.effectiveTo) : null
  if (!from && !to) {
    return true
  }
  if (!from && to) {
    return today <= to
  }
  if (from && !to) {
    return today >= from
  }
  return today >= from && today <= to
}
export const roundFloatNumber = (number, decimals = 2): Number => {
  //https://stackoverflow.com/questions/10473994/javascript-adding-decimal-numbers-issue
  var newnumber = new Number(number).toFixed(decimals)
  return parseFloat(newnumber)
}
